import type { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'glossary',
        name: 'Glossary',
        description: 'Help employees understand your company-specific terms, abbreviations, etc.',
        descriptionLong: (
            <p>
                Define company-specific terms, values, or culture words in the company settings. Whenever a keyword
                appears in user-written text across the app, it will be highlighted and show its explanation. This way,
                your employees can look up terminology while they’re in the flow and don’t have to leave SI to look up
                terms elsewhere.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_glossary',
        imgSrc: require('./images/glossary.jpg'),
        hideIfDisabled: false,
    },
    {
        id: 'review-overview-views',
        name: 'View Presets in Reviews',
        description: 'Browse the Reviews list by Progress or by Results, and store your fine tuned options for later.',
        descriptionLong: (
            <>
                <p>
                    The Review list is highly adjustable, but you need to know what you’re looking for. And once you’ve
                    adjusted the columns and filters and charts to your needs, you need to readjust for the next
                    use-case.
                </p>
                <p>
                    Our new Views give admins smart defaults for tracking progress and for analyzing results. Any
                    adjustment is stored to the screen’s configuration for later.
                </p>
                <p>
                    Soon we’ll include a Calibration view, and mid-term you’ll be able to add your own Views, and share
                    them with peer admins.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewViews',
        imgSrc: require('./images/views.png'),
        hideIfDisabled: false,
    },
];
